import React, { useState, useEffect } from "react";
import TradingViewChart from "./Market-tools/Charts/TradingViewChart";
import OctaFXMT4WebTerminal from "./Market-tools/Charts/OctaFXMT4WebTerminal";
import OctaFXMT5WebTerminal from "./Market-tools/Charts/OctaFXMT5WebTerminal";
import M2TMobileNativeChart from "./Market-tools/Charts/M2TMobileNativeChart"; // Make sure this exists

import MobileAppIcons from "./Mobileview/MobileAppIcons";

// ────────────────────────────────
// Helper for time formatting
// ────────────────────────────────
function pad(n) {
  return n < 10 ? "0" + n : n;
}

// ────────────────────────────────
// Status Bar (always on top, every tab)
// ────────────────────────────────
function MobileStatusBar() {
  const [time, setTime] = useState(() => {
    const d = new Date();
    return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  });

  useEffect(() => {
    // Sync to the next minute, then update every 60s
    const now = new Date();
    const delay = (60 - now.getSeconds()) * 1000;
    let interval;
    const timeout = setTimeout(() => {
      setTime(`${pad(new Date().getHours())}:${pad(new Date().getMinutes())}`);
      interval = setInterval(() => {
        const d = new Date();
        setTime(`${pad(d.getHours())}:${pad(d.getMinutes())}`);
      }, 60000);
    }, delay);
    return () => {
      clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, []);

  return (
    <div
      className="pointer-events-none absolute left-0 top-0 z-40 flex w-full items-center justify-between px-1 py-1 text-[10px]"
      style={{ height: 16 }}
    >
      {/* Live Time */}
      <span className="select-none font-bold text-white/90">{time}</span>
      <span className="flex select-none items-center gap-1 text-white/90">
        {/* Signal Bars */}
        <svg
          width="14"
          height="10"
          viewBox="0 0 14 10"
          className="mr-0.5 inline"
        >
          <rect x="0" y="7" width="2" height="3" fill="#fff" />
          <rect x="3" y="5" width="2" height="5" fill="#fff" />
          <rect x="6" y="3" width="2" height="7" fill="#fff" />
          <rect x="9" y="1" width="2" height="9" fill="#fff" />
        </svg>
        {/* WiFi */}
        <svg width="15" height="12" viewBox="0 0 20 12" className="inline">
          <path
            d="M2 7c4-3.5 12-3.5 16 0"
            stroke="#fff"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M5 9.5c2.5-2 7.5-2 10 0"
            stroke="#fff"
            strokeWidth="1.5"
            fill="none"
          />
          <circle cx="10" cy="11" r="1" fill="#fff" />
        </svg>
        {/* Battery */}
        <svg width="20" height="10" viewBox="0 0 20 10" className="inline">
          <rect
            x="0.5"
            y="1.5"
            width="15"
            height="7"
            rx="2"
            fill="none"
            stroke="#fff"
            strokeWidth="1"
          />
          <rect x="2" y="3" width="12" height="4" rx="1" fill="#fff" />
          <rect x="16" y="4" width="2" height="2" rx="0.5" fill="#fff" />
        </svg>
      </span>
    </div>
  );
}

// ────────────────────────────────
// Main Component
// ────────────────────────────────
export default function M2TMobileScreen({ tab }) {
  const [chartType, setChartType] = useState("tradingview");

  // Layout wrapper for all tabs
  function TabLayout({ children }) {
    return (
      <div className="relative mx-auto min-h-0 w-full max-w-[200px] flex-1 overflow-hidden rounded-2xl bg-[#0f172a]">
        <MobileStatusBar />

        <div className="flex h-full min-h-0 flex-col pl-[1px] pt-12">
          {children}
        </div>
      </div>
    );
  }

  // ───────────────
  // FEED TAB
  // ───────────────
  if (tab === "feed") {
    return (
      <TabLayout>
        <div className="flex w-full flex-col items-center gap-2 overflow-y-auto px-2 pb-2 pt-2">
          {/* Header */}
          <div className="mb-1 w-full text-left text-[7px] font-semibold text-slate-300">
            🔥 Live Feed
          </div>

          {/* Feed 1 */}
          <div className="mx-auto flex w-full max-w-[170px] gap-2 rounded-md bg-[#282b2e] p-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-sky-400 to-blue-700 text-[9px] font-bold text-white">
              TR
            </div>
            <div>
              <div className="text-[10px] font-semibold text-slate-100">
                Trader Raj
              </div>
              <div className="text-[9px] text-blue-300">
                Completed SmartCard KYC
              </div>
              <div className="text-[8px] text-slate-400">1 min ago</div>
            </div>
          </div>

          {/* Feed 2 */}
          <div className="mx-auto flex w-full max-w-[170px] gap-2 rounded-md bg-[#27323d] p-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-full bg-emerald-600 text-[9px] font-bold text-white">
              KD
            </div>
            <div>
              <div className="text-[10px] font-semibold text-slate-100">
                K. Daniel
              </div>
              <div className="text-[9px] text-emerald-300">
                Added funds via Booster
              </div>
              <div className="text-[8px] text-slate-400">3 min ago</div>
            </div>
          </div>

          {/* Feed 3 */}
          <div className="mx-auto flex w-full max-w-[170px] gap-2 rounded-md bg-[#2b2f36] p-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-full bg-purple-600 text-[9px] font-bold text-white">
              AS
            </div>
            <div>
              <div className="text-[10px] font-semibold text-slate-100">
                A. Singh
              </div>
              <div className="text-[9px] text-purple-300">
                Booked 1-to-1 coaching
              </div>
              <div className="text-[8px] text-slate-400">6 min ago</div>
            </div>
          </div>

          {/* Feed 4 */}
          <div className="mx-auto flex w-full max-w-[170px] gap-2 rounded-md bg-[#24303a] p-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-full bg-yellow-500 text-[9px] font-bold text-black">
              MJ
            </div>
            <div>
              <div className="text-[10px] font-semibold text-slate-100">
                M. Joseph
              </div>
              <div className="text-[9px] text-yellow-300">
                Published Gold Signals
              </div>
              <div className="text-[8px] text-slate-400">9 min ago</div>
            </div>
          </div>

          {/* Feed 5 */}
          <div className="mx-auto flex w-full max-w-[170px] gap-2 rounded-md bg-[#262c33] p-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-full bg-pink-600 text-[9px] font-bold text-white">
              LP
            </div>
            <div>
              <div className="text-[10px] font-semibold text-slate-100">
                L. Priya
              </div>
              <div className="text-[9px] text-pink-300">
                Listed AI trading tool
              </div>
              <div className="text-[8px] text-slate-400">12 min ago</div>
            </div>
          </div>

          {/* Feed 6 */}
          <div className="mx-auto flex w-full max-w-[170px] gap-2 rounded-md bg-[#1f2933] p-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-full bg-indigo-600 text-[9px] font-bold text-white">
              VK
            </div>
            <div>
              <div className="text-[10px] font-semibold text-slate-100">
                V. Karthik
              </div>
              <div className="text-[9px] text-indigo-300">
                Applied for analyst role
              </div>
              <div className="text-[8px] text-slate-400">18 min ago</div>
            </div>
          </div>
        </div>
      </TabLayout>
    );
  }

  // ───────────────
  // VIDEO TAB
  // ───────────────
  if (tab === "video") {
    return (
      <TabLayout>
        <div className="flex h-full w-full flex-col gap-3 overflow-auto p-2">
          {/* Header */}
          <div className="mb-1 text-[8px] font-semibold text-slate-300">
            🎥 Live Videos
          </div>

          {/* VIDEO 1 */}
          <div className="relative aspect-[4/5] w-full overflow-hidden rounded-xl bg-black shadow">
            <iframe
              src="https://www.youtube.com/embed/w9QoCKbx6d8?autoplay=1&mute=1&loop=1&playlist=w9QoCKbx6d8"
              title="Video 1"
              allow="autoplay; encrypted-media"
              className="absolute left-0 top-0 h-full w-full"
              style={{ border: 0 }}
            />
          </div>

          {/* VIDEO 2 */}
          <div className="relative aspect-[4/5] w-full overflow-hidden rounded-xl bg-black shadow">
            <iframe
              src="https://www.youtube.com/embed/CG-ZjjM4xSI?autoplay=1&mute=1&loop=1&playlist=CG-ZjjM4xSI"
              title="Video 2"
              allow="autoplay; encrypted-media"
              className="absolute left-0 top-0 h-full w-full"
              style={{ border: 0 }}
            />
          </div>

          {/* VIDEO 3 */}
          <div className="relative aspect-[4/5] w-full overflow-hidden rounded-xl bg-black shadow">
            <iframe
              src="https://www.youtube.com/embed/Qp6S0Onz_iw?autoplay=1&mute=1&loop=1&playlist=Qp6S0Onz_iw"
              title="Video 3"
              allow="autoplay; encrypted-media"
              className="absolute left-0 top-0 h-full w-full"
              style={{ border: 0 }}
            />
          </div>
        </div>
      </TabLayout>
    );
  }

  // ───────────────
  // CHART TAB
  // ───────────────
  if (tab === "chart") {
    return (
      <TabLayout>
        <div className="flex flex-col px-2 pt-3">
          <div className="mb-2 flex w-full items-center justify-between text-[13px] font-semibold text-slate-200">
            <span>📈 Live Market Chart</span>
            <select
              className="ml-2 rounded border border-slate-700 bg-[#191d25] px-2 py-1 text-xs text-slate-100"
              value={chartType}
              onChange={(e) => setChartType(e.target.value)}
              style={{ fontSize: 8, minWidth: 75 }}
            >
              <option value="tradingview">TradingView</option>
              <option value="mt4">MT4</option>
              <option value="mt5">MT5</option>
              <option value="nativechart">Native Chart</option>
            </select>
          </div>

          <div className="mb-2 min-h-[220px] w-full flex-1 overflow-hidden rounded-xl bg-[#151d27]">
            {chartType === "tradingview" && (
              <TradingViewChart symbol="XAUUSD" height={220} />
            )}
            {chartType === "mt4" && <OctaFXMT4WebTerminal />}
            {chartType === "mt5" && <OctaFXMT5WebTerminal />}
            {chartType === "nativechart" && <M2TMobileNativeChart />}
          </div>

          <div className="mt-2 text-xs text-blue-300">
            XAU/USD, BTC/USD — Realtime Updates
          </div>
        </div>
      </TabLayout>
    );
  }

  // ───────────────
  // ALERTS TAB
  // ───────────────
  if (tab === "alerts") {
    return (
      <TabLayout>
        <div className="flex h-full flex-col px-2.5 pb-16 pt-2">
          {/* Header */}
          <div className="mb-1.5 text-[11px] font-medium text-slate-300">
            🔔 Market Alerts
          </div>

          {/* Alerts list */}
          <div className="flex flex-1 flex-col gap-[6px] overflow-y-auto pr-0.5">
            <div className="rounded bg-yellow-600/35 px-2 py-1 text-[10.5px] leading-[1.25] text-yellow-100">
              US CPI today · 11:30 AM EST
            </div>

            <div className="rounded bg-blue-500/35 px-2 py-1 text-[10.5px] leading-[1.25] text-blue-100">
              XAU/USD volatility spike
            </div>

            <div className="rounded bg-emerald-700/35 px-2 py-1 text-[10.5px] leading-[1.25] text-emerald-100">
              New Funded Traders directory added
            </div>

            <div className="rounded bg-purple-600/35 px-2 py-1 text-[10.5px] leading-[1.25] text-purple-100">
              Asia session liquidity sweep
            </div>

            <div className="rounded bg-rose-600/35 px-2 py-1 text-[10.5px] leading-[1.25] text-rose-100">
              High-impact USD news in 30 mins
            </div>

            <div className="rounded bg-sky-600/35 px-2 py-1 text-[10.5px] leading-[1.25] text-sky-100">
              BTC funding rate turning negative
            </div>

            <div className="rounded bg-orange-600/35 px-2 py-1 text-[10.5px] leading-[1.25] text-orange-100">
              NY open volatility window started
            </div>

            {/* ➕ New alerts */}
            <div className="rounded bg-indigo-600/35 px-2 py-1 text-[10.5px] leading-[1.25] text-indigo-100">
              EUR/USD nearing weekly resistance
            </div>

            <div className="rounded bg-lime-600/35 px-2 py-1 text-[10.5px] leading-[1.25] text-lime-100">
              Prop firm payout window opened
            </div>

            <div className="rounded bg-teal-600/35 px-2 py-1 text-[10.5px] leading-[1.25] text-teal-100">
              Gold London fix completed
            </div>

            <div className="rounded bg-fuchsia-600/35 px-2 py-1 text-[10.5px] leading-[1.25] text-fuchsia-100">
              Options expiry day – expect whipsaws
            </div>

            <div className="rounded bg-red-600/35 px-2 py-1 text-[10.5px] leading-[1.25] text-red-100">
              Sudden spike in US 10Y yields
            </div>
          </div>
        </div>
      </TabLayout>
    );
  }

  // ───────────────
  // DIRECTORY TAB
  // ───────────────
  if (tab === "directory") {
    return (
      <TabLayout>
        <div className="px-3 pt-3">
          <div className="mb-2 text-[8px] font-semibold text-slate-200">
            🗂 Directory
          </div>
          <div className="mb-1 flex items-center gap-2 rounded bg-slate-700/60 p-2 text-xs text-slate-200">
            <span className="material-icons text-base text-sky-300">
              verified
            </span>
            <span>
              M2T Verified Traders: <span className="font-semibold">249</span>
            </span>
          </div>
          <div className="flex items-center gap-2 rounded bg-slate-800/60 p-2 text-xs text-slate-200">
            <span className="material-icons text-base text-amber-300">
              groups
            </span>
            <span>
              Companies Listed: <span className="font-semibold">27</span>
            </span>
          </div>
        </div>
      </TabLayout>
    );
  }

  // ───────────────
  // PROFILE TAB
  // ───────────────
  if (tab === "profile") {
    return (
      <TabLayout>
        <div className="flex flex-col items-center justify-center">
          <div className="mb-2 flex h-20 w-20 items-center justify-center rounded-full border-4 border-white bg-gradient-to-tr from-sky-500 to-fuchsia-500 text-3xl font-bold text-white shadow-lg">
            AG
          </div>
          <div className="mb-1 font-semibold text-white">
            A.G. Senthil Kumar
          </div>
          <div className="mb-2 text-xs text-slate-400">Founder & CEO, M2T</div>
          <div className="mb-2 text-xs text-blue-400">@million2trillion</div>
          <button className="rounded bg-blue-700 px-4 py-1 text-xs font-semibold text-white shadow hover:bg-blue-900">
            Edit Profile
          </button>
        </div>
      </TabLayout>
    );
  }

  // ───────────────
  // FALLBACK
  // ───────────────
  return (
    <TabLayout>
      <div className="flex-1" />
    </TabLayout>
  );
}
